<template>
  <div class="registration-view">
    <Registration />
  </div>
</template>

<script>
import Registration from '@/components/Registration.vue'

export default {
  components: {
    Registration,
  },
}
</script>
<style scoped>
.registration-view {
  margin: 1rem;
}
</style>
